import { useQuery } from '@tanstack/react-query'
import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet-async'
import { homeAPI, degreeAPI } from '../../services/api'
import HeroSection from './components/HeroSection'
import StatsSection from './components/StatsSection'
import FeaturedUniversities from './components/FeaturedUniversities'
import TopDegrees from './components/TopDegrees'
import FeaturedBlogs from './components/FeaturedBlogs'
import BannerCarousel from './components/BannerCarousel'
import FAQSection from './components/FAQSection'
import CTASection from './components/CTASection'
import LoadingSpinner from '../../components/Common/LoadingSpinner'
import ErrorMessage from '../../components/Common/ErrorMessage'
import ProcessSection from './components/ProcessSection'

const Home = () => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['homeData'],
        queryFn: homeAPI.getHomeData,
        staleTime: 5 * 60 * 1000, // 5 minutes
    })

    const { data: degreesData, isLoading: degreesLoading } = useQuery({
        queryKey: ['topDegrees'],
        queryFn: () => degreeAPI.getDegrees({ limit: 12, sort: 'order' }),
        staleTime: 10 * 60 * 1000, // 10 minutes
    })

    if (isLoading || degreesLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <LoadingSpinner size="lg" />
            </div>
        )
    }

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <ErrorMessage message="Failed to load homepage data" />
            </div>
        )
    }

    const { banners, stats, featured_universities, recent_faqs } = data.data
    const degrees = degreesData?.data?.degrees || []

    return (
        <>
            <Helmet>
                <title>MyMargdarshak - Your Education Guidance Partner</title>
                <meta name="description" content="Your trusted education guidance platform. Find the best online and distance learning programs from top universities." />
                <meta name="keywords" content="online education, distance learning, MBA, BCA, MCA, UGC recognized, career guidance" />
                <meta property="og:title" content="MyMargdarshak - Your Education Guidance Partner" />
                <meta property="og:description" content="Your trusted education guidance platform. Find the best online and distance learning programs from top universities." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://mymargdarshak.com" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="MyMargdarshak - Your Education Guidance Partner" />
                <meta name="twitter:description" content="Your trusted education guidance platform. Find the best online and distance learning programs from top universities." />
                <link rel="canonical" href="https://mymargdarshak.com" />
            </Helmet>

            <div className="min-h-screen">
                {/* Hero Section with Banner Carousel */}
                <HeroSection banners={banners} />

                {/* Featured Universities */}
                <FeaturedUniversities universities={featured_universities} />


                {/* Top Degrees Section */}
                <TopDegrees degrees={degrees} />

                {/* Stats Section */}
                <StatsSection stats={stats} />

                {/* Featured Blogs */}
                <FeaturedBlogs />

                {/* FAQ Section */}
                <FAQSection faqs={recent_faqs} />

                {/* Growth Process Section */}
                <ProcessSection />

                {/* CTA Section */}
                <CTASection />
            </div>
        </>
    )
}

export default Home
